import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../constants';
import './Header.css';

const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setIsMobileMenuOpen(false);
        }
    };

    const handleAboutClick = (e) => {
        e.preventDefault();
        if (window.location.pathname === '/') {
            scrollToSection('about');
        } else {
            navigate('/');
            setTimeout(() => scrollToSection('about'), 100);
        }
    };

    const handleLogoClick = () => {
        navigate('/');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleHomeClick = (e) => {
        e.preventDefault();
        handleLogoClick();
        setIsMobileMenuOpen(false);
    };

    return (
        <header className={`landing-header ${isScrolled ? 'scrolled' : ''}`}>
            <div className="header-container">
                <div className="header-logo" onClick={handleLogoClick}>
                    <img
                        src="/sks-icons.svg"
                        alt="AzimuthLab Logo"
                        className="logo-img"
                    />
                    <span className="logo-text">AzimuthLab</span>
                </div>

                <nav className={`header-nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
                    <a href="/" onClick={handleHomeClick} className="nav-link">
                        Home
                    </a>
                    <a href="#about" onClick={handleAboutClick} className="nav-link">
                        About
                    </a>
                    <Link to={ROUTES.DOWNLOAD} className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>
                        Download
                    </Link>
                </nav>

                <div className="header-actions">
                    <Link to={ROUTES.LOGIN} className="btn-login">
                        Login
                    </Link>
                </div>

                <button
                    className="mobile-menu-toggle"
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    aria-label="Toggle menu"
                >
                    <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </button>
            </div>
        </header>
    );
};

export default Header;
